import React from "react";

import { AddonInterface } from "../../../../store/mine_craft/addonsSlice";
import Meta, { MetaInterface } from "../../../../componets/Meta";

interface _MetaInterface {
  addon: AddonInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
}

const _Meta = ({ addon, shape, size }: _MetaInterface) => {
  if (!addon) {
    return null;
  }

  return (
    <Meta
      url={addon.url}
      size={size}
      shape={shape}
      avatar={addon.image_url}
      title={addon.title}
    />
  );
}

export default _Meta;
